import {request} from '../../helpers/request'
import React from 'react'
import {Table} from 'react-bootstrap'
import LoadingComponent from '../common/LoadingComponent'
import {t} from '../../helpers/translate'
import {checkOrg} from '../../helpers/access'
let config = require('config');

class NoteComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      noteContent: '',
      saving: false
    };
  }

  renderNotes () {
    return (
      <tbody>
      { this.props.notes.map(
        (note, index) => {
          var session_data = JSON.parse(note.user_data).session_data;
          return (
            <tr key={index}>
              {this.renderTableCell(`${session_data.first_name} ${session_data.last_name}`)} 
              {this.renderTableCell(note.created_at)}
              {this.renderTableCell(note.content)}
            </tr>
          )
        })
        }
      </tbody>
    )
  }

  handleNoteChange(event) {
    this.setState({
      noteContent: event.target.value
    });
  }

  toggleSaving(){
    this.setState({
      saving: !this.state.saving
    })
  }

  saveNote(event) {
    this.toggleSaving();
    (this.state.noteContent.length > 0) && request(`${config.default.api}/note/${this.props.source}/${this.props.applicationId}`, 'POST',
      { 'content': this.state.noteContent }, 
      (data, status) => {
        this.toggleSaving();
        if (status == 200) {
          this.state.noteContent = '';
          this.props.showModal('Success', 'The note has been added');
          this.props.loadData();
        } else {
          this.showModal('Error', <div>{data.messages.map((message) =>
            <p>{message}</p>)}</div>);
          event.preventDefault();
        }
      },
      { 'Content-Type': 'application/json'},
    );
  }

  renderTableCell (value) {
    return <td>{value}</td>
  }

  renderEmptyCell(){
    return <td></td>
  }

  render() {
    const tableHead = [t('User'), t('Date'), t('Note Content')];

    return <div>
      <div>
        <LoadingComponent show={this.state.saving} text='Saving Note'/>
        <textarea width="50" height='10' placeholder={t('Enter note here')}
          className='note_textarea'
          onChange={this.handleNoteChange.bind(this)}
          value={this.state.noteContent}
        />
        <button className="btn button-secondary" disabled={this.state.noteContent.length == 0} onClick={this.saveNote.bind(this)}>
          {t('Add Note')}
        </button>
      </div>
      {this.props.notes.length > 0 &&
        <Table striped condensed hover id='noteTable'>
          <thead>
            <tr>
            {tableHead.map((header, index) => <th key={index}>{header}</th>)}
            </tr>
          </thead>
          {this.renderNotes()}
        </Table>
      }
    </div>
  }
}
NoteComponent.displayName = 'NoteComponent';
export default NoteComponent;


// WEBPACK FOOTER //
// ./src/components/common/NoteComponent.js